'use strict'

module.exports = [

	{name: 'event-list', groups: ['Kalendár'],
		sections: ['full', 'large', 'small'],
	},
	{name: 'event-calendar', groups: ['Kalendár'],
		sections: ['full', 'large', 'small'],
	},
	{name: 'event-detail', groups: ['Kalendár'],
		sections: ['full', 'large', 'small'],
	},

]



//////////////////
// WEBPACK FOOTER
// ./src/blocks/_multi-calendar.js
// module id = 147
// module chunks = 0